/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { ColFilterPipe, ColShowFilterPipe } from '../pipes/ColumnSelectorPipe';

export class ColumnCustomModalContext {
  actionFrom: string = '';
}

@Component({
  selector: 'cc-column-selector-modal',
  templateUrl: './column-modal.component.html',
  styleUrls: ['./column-modal.component.scss'],
  providers: [ColFilterPipe, ColShowFilterPipe]
})

export class ColumnSelectorModalComponent implements OnInit {
  @Output() onClose: EventEmitter<string> = new EventEmitter<string>();
  public columnSets: any = [];
  public selectedColumns: any = [];
  public selectedColumnsCount: any = {};
  public userMessage = '';
  public globalFilterValue = '';
  public actionFrom!: string;
  public columnSetsName: any;
  public selColSetName: any;

  constructor(
    public bsModalRef: BsModalRef,
    public colShowFilterPipe: ColShowFilterPipe,
    public colFilterPipe: ColFilterPipe,
    private commonService: CommonService
  ) {
    this.commonService.columnChange.subscribe(() => {
      this.initialize();
    });
  }

  ngOnInit() {
    this.initialize();
  }
  
  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  private initialize() {
    this.columnSets = this.commonService.getAllColumnSets();
    this.selectedColumns = this.commonService.getSelectedColumns();
    this.columnSetsName = this.commonService.getColumnSetsName();
    this.prepareColumnData();
    if (this.columnSets.length) {
      setTimeout(() => {
        if (this.columnSetsName == 'Orders') {
          let index = 0;
          this.columnSets.forEach((colSet: any, idx: number) => {
            if (colSet.visible) {
              index = idx;
            }
          });
          this.displayColumns(index, false);
        } else {
          this.displayColumns(0, false);
        }
      }, 100);
    } else {
      this.userMessage = this.getTranslationWithKey('acm_col_not_available');
    }
  }

  private prepareColumnData() {
    /* Prepare columns by Category */
    const columnsInfo: any = {};
    this.selectedColumns.forEach((item: any) => {
      if (!columnsInfo[item.columnSetBelongsTo]) {
        const temp = item.columnSetBelongsTo;
        columnsInfo[temp] = [];
        columnsInfo[temp].push(item.column?.name);
      } else {
        columnsInfo[item.columnSetBelongsTo].push(item.column?.name);
      }
    });
    /* Check if a category is present or not and uncheck all columns */
    const columnCategories = Object.keys(columnsInfo);
    this.columnSets.forEach((columnSet: any) => {
      if (columnCategories.indexOf(columnSet.name) <= -1) {
        columnSet.columns.forEach((column: any) => {
          if (column.columns && column.columns.length > 0) {
            column.columns.forEach((subColumn: any) => {
              subColumn.isChecked = false;
            });
          } else {
            column.isChecked = false;
          }
        });
        if (columnSet.columnSubGroups && columnSet.columnSubGroups.length) {
          for (const column of columnSet.columnSubGroups) {
            if (column.columns && column.columns.length > 0) {
              for (const subColumn of column.columns) {
                if (subColumn.columns && subColumn.columns.length > 0) {
                  for (const subGroup of subColumn.columns) {
                    subGroup.isChecked = false;
                  }
                } else {
                  subColumn.isChecked = false;
                }
              }
            } else {
              column.isChecked = false;
            }
          }
        }
      } else {
        const columnsEntries = columnsInfo[columnSet.name];
        if (columnSet.columnSubGroups) {
          for (const colSubGrp of columnSet.columnSubGroups) {
            for (const column of colSubGrp.columns) {
              if (column.columns && column.columns.length > 0) {
                for (const subCol of column.columns) {
                  if (columnsEntries.indexOf(subCol.name) <= -1) {
                    subCol.isChecked = false;
                  } else {
                    subCol.isChecked = true;
                  }
                }
              }
              if (columnsEntries.indexOf(column.name) <= -1) {
                column.isChecked = false;
              } else {
                column.isChecked = true;
              }
            }
          }
        }
        for (const column of columnSet.columns) {
          if (column.columns && column.columns.length > 0) {
            for (const subCol of column.columns) {
              if (columnsEntries.indexOf(subCol.name) <= -1) {
                subCol.isChecked = false;
              } else {
                subCol.isChecked = true;
              }
            }
          }
          if (columnsEntries.indexOf(column.name) <= -1) {
            column.isChecked = false;
          } else {
            column.isChecked = true;
          }
        }
      }
    });
    this.groupColumns();
  }

  private groupColumns() {
    let tempColObj: any = {},
      tempSubColObj: any = {};
    for (const columnSets of this.columnSets) {
      tempColObj = {};
      let colIndex = -1;
      for (const directColumn of columnSets.columns) {
        colIndex++;
        if (directColumn.groupName) {
          if (!tempColObj[directColumn.groupName]) {
            tempColObj[directColumn.groupName] = [];
          }
          tempColObj[directColumn.groupName].push(directColumn);
          columnSets.columns[colIndex] = {};
        }
      }
      const arrCol = [];
      columnSets.columns = columnSets.columns || [];
      for (let c = 0; c < columnSets.columns.length; c++) {
        if (Object.keys(columnSets.columns[c]) && Object.keys(columnSets.columns[c]).length > 0) {
          arrCol.push(columnSets.columns[c]);
        }
      }
      columnSets.columns = arrCol;
      for (const directCol in tempColObj) {
        const colObj: any = {};
        colObj.label = directCol;
        colObj.columns = tempColObj[directCol];
        columnSets.columns.push(colObj);
      }

      tempSubColObj = {};
      let subColIndex = -1;
      if (columnSets.columnSubGroups) {
        for (const relatedColumn of columnSets.columnSubGroups) {
          subColIndex = -1;
          tempSubColObj = {};
          relatedColumn.columns = relatedColumn.columns || [];
          for (const subColumn of relatedColumn.columns) {
            subColIndex++;
            if (subColumn.groupName) {
              if (!tempSubColObj[subColumn.groupName]) {
                tempSubColObj[subColumn.groupName] = [];
              }
              tempSubColObj[subColumn.groupName].push(subColumn);
              relatedColumn.columns[subColIndex] = {};
            }
          }
          const arrSubCol = [];
          for (let c = 0; c < relatedColumn.columns.length; c++) {
            if (Object.keys(relatedColumn.columns[c]).length > 0) {
              arrSubCol.push(relatedColumn.columns[c]);
            }
          }
          relatedColumn.columns = arrSubCol;
          for (const subCol in tempSubColObj) {
            const colObj: any = {};
            colObj.label = subCol;
            colObj.columns = tempSubColObj[subCol];
            relatedColumn.columns.push(colObj);
          }
        }
      }
    }
  }

  public closeModalWindow() {
    this.onClose.emit('closed');
    this.bsModalRef.hide();
  }

  public saveModalContent() {
    if (this.columnSetsName == 'Orders') {
      let selColSet: any;
      const selectedColumns: any = [];
      this.columnSets.forEach((columnSet: any) => {
        if (columnSet.visible) {
          selColSet = columnSet.name;
        }
      });
      this.selectedColumns.forEach((columnSet: any) => {
        if (columnSet.columnSetBelongsTo == selColSet) {
          selectedColumns.push(columnSet);
        }
      });
      this.commonService.setSelectedColumns(selectedColumns);
    } else if (this.columnSetsName == 'Incentives') {
      const selectedColumns: any = [];
      this.columnSets.forEach((columnSet: any) => {
        columnSet.columnSubGroups.forEach((colSubGrp: any) => {
          if (
            ((colSubGrp.name == 'Incentive Point' || colSubGrp.name == 'Incentive Program') &&
              this.selColSetName == colSubGrp.name) ||
            (colSubGrp.name !== 'Incentive Point' && colSubGrp.name !== 'Incentive Program')
          ) {
            colSubGrp.columns.forEach((col: any) => {
              if (col.isChecked && !col.columns) {
                const tempColumnObj: any = {};
                tempColumnObj.column = col;
                tempColumnObj.columnSetBelongsTo = columnSet.name;
                selectedColumns.push(tempColumnObj);
              } else if (col.columns) {
                col.columns.forEach((col: any) => {
                  if (col.isChecked && !col.columns) {
                    const tempColumnObj: any = {};
                    tempColumnObj.column = col;
                    tempColumnObj.columnSetBelongsTo = columnSet.name;
                    selectedColumns.push(tempColumnObj);
                  }
                });
              }
            });
          }
        });
      });
      this.commonService.setSelectedColumns(selectedColumns);
    } else {
      this.commonService.setSelectedColumns(this.selectedColumns);
    }
    this.onClose.emit('saved');
    this.bsModalRef.hide();
  }

  public onColumnSelectionChange(event: any, column: any) {
    this.updateColumnSelectionCount();
  }

  public onMainColumnSelectionChange(evt: any, column: any) {
    this.selColSetName = column.name;
  }

  private updateColumnSelectionCount() {
    this.selectedColumnsCount = {};
    this.selectedColumns = [];
    for (const columnSet of this.columnSets) {
      let columnSetCount = 0;
      for (const column of columnSet.columns) {
        if (column.columns) {
          for (const colGrp of column.columns) {
            if (colGrp.isChecked) {
              columnSetCount++;
              this.createAddColumn(this.selectedColumns, colGrp, columnSet.name);
            }
          }
        } else {
          if (column.isChecked) {
            columnSetCount++;
            this.createAddColumn(this.selectedColumns, column, columnSet.name);
          }
        }
      }
      if (columnSet.columnSubGroups) {
        for (const subColumn of columnSet.columnSubGroups) {
          for (const column of subColumn.columns) {
            if (column.columns) {
              for (const colGrp of column.columns) {
                if (colGrp.isChecked) {
                  columnSetCount++;
                  this.createAddColumn(this.selectedColumns, colGrp, columnSet.name);
                }
              }
            } else {
              if (column.isChecked) {
                columnSetCount++;
                this.createAddColumn(this.selectedColumns, column, columnSet.name);
              }
            }
          }
        }
      }
      this.selectedColumnsCount[columnSet.name] = columnSetCount;
    }
  }

  private createAddColumn(input: Array<any>, column: any, belongsToName: string) {
    const tempColumnObj: any = {};
    tempColumnObj.column = column;
    tempColumnObj.columnSetBelongsTo = belongsToName;
    input.push(tempColumnObj);
  }

  private resetColumnSets() {
    for (const columnSet of this.columnSets) {
      columnSet.visible = false;
    }
  }

  public displayColumns(index: any, html: any) {
    this.resetColumnSets();
    if (html) {
      index = this.incIndex(index);
    }
    setTimeout(() => {
      if (this.columnSets[index]) {
        this.columnSets[index].visible = true;
        this.displayRelatedColumns(index, 0, false);
      }
    }, 0);
  }

  private resetRelatedColumnSets(index: number) {
    if (this.columnSets[index] && this.columnSets[index].columnSubGroups) {
      for (const columnSet of this.columnSets[index].columnSubGroups) {
        columnSet.visible = false;
      }
    }
  }

  public displayRelatedColumns(index: any, relIndex: any, html: any) {
    if (html) {
      index = this.incIndex(index);
    }

    this.resetRelatedColumnSets(index);
    if (this.columnSets[index] && this.columnSets[index].columnSubGroups) {
      relIndex = this.incSubIndex(index, relIndex);
      if (this.columnSets[index].columnSubGroups.length && this.columnSets[index].columnSubGroups[relIndex]) {
        this.columnSets[index].columnSubGroups[relIndex].visible = true;
        if (!this.selColSetName || this.columnSetsName == 'Incentives') {
          this.columnSets[index].columnSubGroups.forEach((col: any) => {
            if (col.name == 'Incentive Point' || col.name == 'Incentive Program') {
              col.columns.forEach((selCol: any) => {
                if (selCol.isChecked) {
                  this.selColSetName = col.name;
                }
              });
            }
          });
        }
        if (
          this.columnSets[index].columnSubGroups[relIndex].name == 'Incentive Point' ||
          this.columnSets[index].columnSubGroups[relIndex] == 'Incentive Program'
        ) {
          this.onMainColumnSelectionChange(null, this.columnSets[index].columnSubGroups[relIndex]);
        }
      }
    }
  }

  private incIndex(index: number) {
    let inc = -1,
      finVal;
    for (let i = 0; i < this.columnSets.length; i++) {
      if (this.columnSets[i] && this.columnSets[i].show) {
        inc = inc + 1;
        if (index == inc) {
          finVal = i;
          break;
        }
      }
    }
    return finVal;
  }

  private incSubIndex(index: number, relIndex: any) {
    let inc = -1,
      finVal;
    for (let i = 0; i < this.columnSets[index].columnSubGroups.length; i++) {
      if (this.columnSets[index].columnSubGroups[i] && this.columnSets[index].columnSubGroups[i].show) {
        inc = inc + 1;
        if (relIndex == inc) {
          finVal = i;
          break;
        }
      }
    }
    return finVal;
  }

  public selectAllColumns(valState: any) {
    /* Check if a category is present or not and uncheck all columns */
    for (const columnSet of this.columnSets) {
      for (const column of columnSet.columns) {
        if (column.columns && column.columns.length > 0) {
          for (const subColumn of column.columns) {
            subColumn.isChecked = valState;
          }
        } else {
          column.isChecked = valState;
        }
      }
      if (columnSet.columnSubGroups && columnSet.columnSubGroups.length) {
        for (const column of columnSet.columnSubGroups) {
          if (column.columns && column.columns.length > 0) {
            for (const subColumn of column.columns) {
              if (subColumn.columns && subColumn.columns.length > 0) {
                for (const subGroup of subColumn.columns) {
                  subGroup.isChecked = valState;
                }
              } else {
                subColumn.isChecked = valState;
              }
            }
          } else {
            column.isChecked = valState;
          }
        }
      }
    }
    this.updateColumnSelectionCount();
  }

  public search(evt: any) {
    setTimeout(() => {
      this.displayColumns(0, false);
    }, 100);
  }

  public clearFilter() {
    this.globalFilterValue = '';
    setTimeout(() => {
      this.displayColumns(0, false);
    }, 100);
  }
}
